import Image from 'next/image';
import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';

export const CreateGfFeature = () => {
  return (
    <section className="w-full max-w-screen-xl mx-auto mt-[60px] pb-[24px]">
      <div className="flex flex-col justify-center items-center mx-[4px] mt-[10px] lg:mt-0 lg:grid lg:grid-cols-2 lg:mx-auto">
        <div className="shadow-darkRed h-full max-w-260 md:max-w-80 md:h-80 relative overflow-hidden rounded-[16px] !my-2 md:!mb-0 lg:hidden">
          <img
            width={300}
            height={428}
            src="/sections/ai-porn-chat/perfect-girl.jpg"
            alt="Beautiful AI girl"
            className={clsx(
              'lg:hidden',
              'h-full max-w-[576px]',
              'rounded-[12px]',
            )}
          />
        </div>
        <div className="text-center md:text-start m-5">
          <h2 className="font-bold">Craft Your Perfect AI Girl</h2>
          <div className="text-wtf-white text-xs">
            <p>
              The key to the best ai porn chat experience is having the perfect
              partner, wouldn&apos;t you agree? Today might just be your lucky
              day because you have the power to customize every detail to{' '}
              <Link
                href={'/create-your-ai-girlfriend'}
                className={'!underline font-bold '}
              >
                create your dream girl.
              </Link>
            </p>
            <p>
              Fancy blondes with big breast? Or perhaps athletic ginger girls
              are more your style? What about her{' '}
              <span className="text-highlight font-semibold">
                intimate kinks?{' '}
              </span>
              We&apos;ve got you covered.
            </p>
            <p>
              Every intricate detail is at your fingertips. Dive into our
              premier AI Girlfriend Builder and embark on an unforgettable porn
              AI chat adventure.
            </p>
          </div>
        </div>
        <div
          className={clsx(
            'flex-[1] basis-1/3',
            'max-w-[828px]',
            'hidden lg:!flex lg:!flex-row lg:!justify-center lg:!items-center',
          )}
        >
          <img
            src="/sections/ai-porn-chat/perfect-girl.jpg"
            alt="AI generated image of girl in white shirt"
            width={428}
            height={428}
            className="rounded-[12px]"
          />
        </div>
      </div>
    </section>
  );
};
